import React from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import { titleize } from 'inflect';

import Avatar from './Avatar';
import { getLevel } from '../helpers';

const ProfileSmry = ({
  levels,
  user,
}) => {
  const { i18n, t } = useTranslation();
  const lv = getLevel(levels, user.score);
  const nextLv = lv.next || lv.current;

  return (
    <div className="row align-items-center">
      <div className="col-auto" style={{ width: '40%' }}>
        <Avatar />
        <div className="text-center fw-bold mt-3">
          {i18n.pickLng(lv.current.title)}
        </div>
      </div>
      <div className="col">
        <h6 className="fw-bold d-flex justify-content-between">
          <div>{titleize(t('progress'))}</div>
          <div>
            {user.score}
            /
            {nextLv.score}
            +
          </div>
        </h6>
        <div className="progress my-4" style={{ height: '2rem' }}>
          <div
            className="progress-bar"
            style={{
              width: `${
                Math.round((user.score / nextLv.score) * 100)
              }%`,
            }}
          />
        </div>
        <NavLink to="profile" className="btn btn-rock-3 fontBorder">
          {t('details', 'Details')}
        </NavLink>
      </div>
    </div>
  );
};

export default ProfileSmry;
